import React, { useMemo } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
  ColumnDef,
} from "@tanstack/react-table";
import { User } from "@/types";
import { Alert, Dropdown } from "react-bootstrap";
import Breadcrumb from "./Breadcrumb";

type Props = {
  data: User[];
  heading: string;
};

const NotificationComponent: React.FC<Props> = ({ data, heading }) => {
  const columns = useMemo<ColumnDef<User>[]>(
    () => [
      {
        accessorKey: "name",
        header: ({ column }) => (
          <div onClick={() => column.toggleSorting()}>
            Name{" "}
            {column.getIsSorted() === "asc"
              ? "🔼"
              : column.getIsSorted() === "desc"
              ? "🔽"
              : ""}
          </div>
        ),
        cell: (info) => info.getValue(),
      },
      {
        accessorKey: "email",
        header: "Email",
        cell: (info) => info.getValue(),
      },
      {
        accessorKey: "role",
        header: "Role",
        cell: (info) => info.getValue(),
      },
      {
        accessorKey: "number",
        header: ({ column }) => (
          <div onClick={() => column.toggleSorting()}>
            Number{" "}
            {column.getIsSorted() === "asc"
              ? "🔼"
              : column.getIsSorted() === "desc"
              ? "🔽"
              : ""}
          </div>
        ),
        cell: (info) => info.getValue(),
      },
      {
        accessorKey: "position",
        header: ({ column }) => (
          <div onClick={() => column.toggleSorting()}>
            position{" "}
            {column.getIsSorted() === "asc"
              ? "🔼"
              : column.getIsSorted() === "desc"
              ? "🔽"
              : ""}
          </div>
        ),

        cell: (info) => info.getValue(),
      },
      {
        header: "Actions",
        cell: () => (
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              Notification Action
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Read</Dropdown.Item>
              <Dropdown.Item>UnRead</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ),
      },
    ],
    []
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {},
  });

  return (
    <>
      <Breadcrumb />
      <Alert className="text-center">{heading.toUpperCase()}</Alert>
      <div className="custom-card">
        <table className="styled-table">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id}>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default NotificationComponent;
